import { __assign, __awaiter, __extends, __generator } from "tslib";
import { Status } from '@amplitude/types';
import { AsyncQueue, collectInvalidEventIndices } from '@amplitude/utils';
import { BaseRetryHandler } from './baseRetry';
/**
 * A retry handler made specifically to handle a strategy where
 * the server network connection is not always available. (e.g. executing node code on a client device).
 * Instead of retrying events on a loop, this will save untried events
 */
var OfflineRetryHandler = /** @class */ (function (_super) {
    __extends(OfflineRetryHandler, _super);
    function OfflineRetryHandler(apiKey, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, apiKey, options) || this;
        _this._eventsToRetry = [];
        _this._requestQueue = new AsyncQueue();
        return _this;
    }
    /**
     * @inheritDoc
     */
    OfflineRetryHandler.prototype.sendEventsWithRetry = function (events) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._requestQueue.addToQueue(function () { return __awaiter(_this, void 0, void 0, function () {
                            var response, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        response = { status: Status.Unknown, statusCode: 0 };
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([1, 3, , 4]);
                                        return [4 /*yield*/, this._transport.sendPayload(this._getPayload(events))];
                                    case 2:
                                        response = _b.sent();
                                        if (response.status !== Status.Success) {
                                            throw new Error(response.status);
                                        }
                                        else {
                                            this._onSendSuccess();
                                        }
                                        return [3 /*break*/, 4];
                                    case 3:
                                        _a = _b.sent();
                                        this._onSendError(events, response);
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/, response];
                                }
                            });
                        }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OfflineRetryHandler.prototype._getPayload = function (events) {
        return __assign({ api_key: this._apiKey, events: this._eventsToRetry.concat(events) }, this._getPayloadOptions());
    };
    OfflineRetryHandler.prototype._onSendSuccess = function () {
        // If we successfully sent all the events, reset the queue!
        this._eventsToRetry = [];
    };
    OfflineRetryHandler.prototype._onSendError = function (events, response) {
        var _a;
        var newEventsToRetry = Array.from(events);
        // See if there are any events we can immediately throw out
        if (response.status === Status.Invalid) {
            if (typeof ((_a = response.body) === null || _a === void 0 ? void 0 : _a.missingField) === 'string' || events.length === 1) {
                // Don't retry anything if there's an issue with the entire payload
                // or if there's only one event and its invalid
                newEventsToRetry = [];
            }
            else if (response.body !== undefined) {
                var invalidEventIndices_1 = new Set(collectInvalidEventIndices(response));
                newEventsToRetry = events.filter(function (_, index) { return !invalidEventIndices_1.has(index); });
            }
        }
        else if (response.status === Status.Success) {
            // In case _onEventsError was called when we were actually successful
            // In which case, why even start retrying events?
            newEventsToRetry = [];
        }
        this._eventsToRetry = newEventsToRetry;
        // If we have too many events, delete the OLDEST events.
        if (this._eventsToRetry.length > this._options.maxCachedEvents) {
            var numExceededEvents = this._eventsToRetry.length - this._options.maxCachedEvents;
            this._eventsToRetry.splice(0, numExceededEvents);
        }
    };
    return OfflineRetryHandler;
}(BaseRetryHandler));
export { OfflineRetryHandler };
//# sourceMappingURL=offlineRetry.js.map